<template>
  <div class="course_list">
    <p class="hint" v-if="JSON.stringify(list) == '[]'">暂无课时</p>
    <div class="content_box" :class="[list.length < 3 ? 'special' : '']">
      <div
        :class="[
          'content',
          'content_' + item.web_custom_type,
          isNoviceClass ? 'novice_class' : '',
          'cursor',
          'shadow' + subType,
        ]"
        v-for="(item, index) in list"
        :key="index"
        @click="go_page(item.web_custom_type, item)"
      >
        <div
          class="practiceStatus"
          v-if="
            practiceStatus[item.practiceStatus] &&
            item.lessonType == 7 &&
            item.web_custom_type > 1
          "
          v-text="practiceStatus[item.practiceStatus]"
        ></div>
        <span
          :class="[
            'icon',

            subject <= 6 && !isNoviceClass ? 'icon' + subject : '',
            item.lessonType == 6 ? 'icon_yx' : '',
            item.lessonType == 3 ? 'icon_xt' : '',
          ]"
        >
          <img
            ondragstart="return false;"
            :src="
              '/static/img/course/number/' +
              subType +
              '/compose/' +
              getLessionType(item) +
              '.png'
            "
            alt
          />
          <div
            v-if="item.web_custom_type < 2"
            class="lock"
            style="
               {
                position: 'absolute';
                width: 111px;
                height: 111px;
                zindex: 10;
              }
            "
          ></div>
          <!-- <img
            v-if="item.web_custom_type < 2"
            src="/static/img/course/iconbg/lock.png"
          style="{position: 'absolute'; zIndex: 10;}">-->
        </span>
        <!-- <img
          class="headset"
          :src="isNoviceClass?'/static/img/course/novice_headset.png':subject==1 || subject==2 || subject==3 ? '/static/img/course/'+subject+'headset.png':'/static/img/course/mheadset.png'"
          alt
        />-->
        <div :class="['u-time-box', 'u-time']">
          <template>{{ item.me_begin_time_man }}</template>
        </div>
        <span
          class="text bold"
          :class="[
            item.web_custom_type > 1
              ? subject <= 6
                ? 'text' + subject
                : ''
              : subject <= 6
              ? 'text' + subject + ''
              : '',
          ]"
          >{{ item.lessonTypeName }}</span
        >
        <div
          v-if="
            item.web_custom_type == 3 &&
            item.isPlay == 0 &&
            (item.lessonType == 3 ||
              item.lessonType == 6 ||
              (item.lessonType == 7 && item.practiceStatus != 12))
          "
          class="attend_class zhengyuantop"
          :class="['classing' + subType]"
          v-text="btnTxt(item)"
        ></div>

        <div
          v-if="
            item.web_custom_type == 3 &&
            item.lessonType != 3 &&
            item.lessonType != 6 &&
            item.lessonType != 7
          "
        >
          <div
            v-if="item.playbackUrl == ''"
            class="attend_class newback"
            :class="['classing' + subType]"
          >
            <img
              :src="'/static/img/course/iconbg/empty.png'"
              style="width: 15px; margin-right: 10px"
              alt
            />
            <div class="zhengyuantop">回放生成中</div>
          </div>
          <div
            v-if="!!item.playbackUrl"
            class="attend_class newback"
            :class="['classing' + subType]"
          >
            <img
              v-if="item.isPlay == 1"
              :src="
                '/static/img/course/number/' +
                subType +
                '/compose/live_fini.png'
              "
              style="width: 18px; marginright: 10px; margintop: 1px"
              alt
            />
            <div class="zhengyuantop">看回放</div>
          </div>
        </div>
        <div
          v-if="
            item.web_custom_type == 3 &&
            ((item.isPlay == 1 &&
              (item.lessonType == 3 || item.lessonType == 6)) ||
              (item.lessonType == 7 && item.practiceStatus == 12))
          "
        >
          <img
            :src="
              '/static/img/course/number/' + subType + '/compose/finish.png'
            "
            style="width: 63px"
            alt
          />
        </div>
        <div
          v-if="item.web_custom_type < 2"
          class="attend_class zhengyuantop"
          :class="['bcoin' + subject]"
        >
          <!-- {{ item.me_begin_time_man }} -->
          待开课
        </div>
        <div
          v-if="item.web_custom_type == 2"
          class="attend_class"
          :class="['classing' + subType]"
        >
          <div
            class="lottie_voice"
            v-if="item.web_custom_type == 2 && showCompose"
          ></div>
          <div class="zhengyuantop">正在直播</div>
        </div>
        <!-- <b
          v-if="item.web_custom_type!=2 && (item.web_custom_type==3 && (item.lesson_type == 3 ||item.lesson_type == 6 )? false : true)"
          :class="[item.web_custom_type==1 ? 'classing'+subType :(subject<=4 ? 'bcoin'+subject :'bcoin4')]"
        >
        {{item.web_custom_type==1 || item.web_custom_type==0 ?item.me_begin_time_man:item.coin}}</b>-->
      </div>
      <icp />
    </div>
    <toast
      :showText="showText"
      v-if="showText"
      @toastCallBack="showText = ''"
    ></toast>
    <loadError
      textColor="#fff"
      style="margin-top: -83px"
      @loadAgain="getDataAgain"
      v-if="loadErrorShow"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import courseAlert from "./course_alert";
import toast from "../../basic/toast";
import loadError from "../../basic/loadError";
import icp from "@/components/basic/icp.vue";
import lottie from "lottie-web-limi";
import common from "common";
export default {
  name: "compose_list",
  props: ["subType"],
  data() {
    return {
      list: "",
      alertData: {},
      num: 0,
      showText: "",
      practiceStatus: {
        0: "未完成",
        10: "未完成",
        11: "待订正",
      },
      loadErrorShow: false,
      anim: false,
      lottie: false,
    };
  },
  components: {
    courseAlert,
    toast,
    loadError,
    icp,
  },
  computed: {
    ...mapState([
      "subject",
      "lesson_id",
      "liveVideoUrlData",
      "isNoviceClass",
      "composeLessInfo",
      "showCompose",
      "isGhost",
    ]),
    ...mapGetters(["isExperientialCourse"]),
  },
  mounted() {
    this.init();
    this.$nextTick(() => {
      if (this.list.some((x) => x.web_custom_type == 2)) {
        this.playAmn();
      }
    });
  },
  methods: {
    ...mapActions(["getZip"]),
    ...mapMutations([
      "savePlaybackData",
      "updataVideoUrlState",
      "refreshNet",
      "saveLessonInfo",
    ]),
    init() {
      this.formatData(this.composeLessInfo);
    },
    btnTxt(item) {
      if (item.lessonType == 7) {
        if (item.practiceStatus == 11) {
          return "去订正";
        }
        return "去交作业";
      }
      return "开始学习";
    },
    getLessionType(i) {
      let type = "";
      let item = i;
      switch (true) {
        case item.lessonType == 1:
          type = "live";
          break;
        case item.lessonType == 7:
          type = "homework";
          break;
        case item.lessonType == 6:
          type = "prev";
          break;
        case item.lessonType == 3:
          type = "exer";
          break;
        default:
          type = "live";
          break;
      }
      return type;
    },
    getLessionTypeName(i) {
      let type = "";
      let item = i;
      switch (true) {
        case item.lessonType == 3:
          type = "习题课";
          break;
        case item.lessonType == 6:
          type = "预习课";
          break;
        default:
          type = "直播课";
          break;
      }
      return type;
    },
    formatData(res) {
      this.alertData = {};
      //给数据增加所有要的web_custom_type标识
      res.lessonListChild.forEach((v, i) => {
        let type = 0;
        v.coin = res.coin;
        //0未上课 1等待上课 2正在上课 3上完课
        if (v.isNextLesson == 1) {
          if (v.state == 2) {
            type = 2;
            if (this.$route.query["from"] !== "video") {
              if (this.subject == 3) {
                this.alertData = {
                  show: true,
                  btn: "进入",
                  cancal: "取消",
                  lessonName: v.title,
                  imgNum: v.sort,
                  data: v,
                };
              } else {
                this.alertData = {
                  show: true,
                  btn: "进入",
                  cancal: "取消",
                  lessonName: v.title,
                  imgNum: i + 1,
                  data: v,
                };
              }
              this.$root.eventHub.$emit("createLog", {
                id: "LMTrackEventLivingNotice",
              });
            }
          } else {
            if (!!v.beginTime) {
              let metime = v.beginTime.split(" ")[0];
              if (metime) {
                let arr = metime.split("-");
                if ((v.lessonType == 1 || v.lessonType == 5) && v.state != 3) {
                  metime = `${arr[1]}月${arr[2]}日 ${v.beginTimeSlot || ""}`;
                } else {
                  metime = `${arr[1]}月${arr[2]}日`;
                }
              } else {
                metime = "等待开课";
              }
              v.me_begin_time_man = metime;
            }
            type = v.state == 3 ? 3 : 1;
          }
          if (LIMI_ENV === "electron" && this.$route.query.from !== "video") {
            this.getZip({ course_id: v.courseId });
          }
        } else {
          type = v.state == 1 ? 0 : v.state;
          if (!!v.beginTime) {
            let metime = v.beginTime.split(" ")[0];
            let arr = metime.split("-");
            if ((v.lessonType == 1 || v.lessonType == 5) && v.state != 3) {
              metime = `${arr[1]}月${arr[2]}日 ${v.beginTimeSlot || ""}`;
            } else {
              metime = `${arr[1]}月${arr[2]}日`;
            }
            v.me_begin_time_man = metime;
          }
        }
        let beginTime =
          new Date(v.beginTime.replace(/-/g, "/")).getTime() / 1000;
        if (
          v.lessonType == 7 &&
          (common.getTemServerTime() > beginTime || this.isGhost)
        ) {
          type = 3;
        }
        v.web_custom_type = type;
        if (
          LIMI_ENV === "electron" &&
          this.isExperientialCourse &&
          this.$route.query.from !== "video"
        ) {
          this.getZip({ course_id: v.courseId });
        }
      });
      this.list = res.lessonListChild;
    },
    splitIndex(index) {
      //课时点索引截取为数组
      var index = new String(index);
      if (index.length == 1) {
        return [index];
      } else {
        return index.split("");
      }
    },
    splitIndexEnglish(index) {
      if (index != 0) {
        var index = new String(index);
        if (index.length == 1) {
          return [index];
        } else {
          return index.split("");
        }
      } else {
        return [index];
      }
    },
    scrollTop() {
      //滚动到正在上课的课时点的位置
      var dom = document.getElementsByClassName("course_list")[0];
      var dom1 = document.getElementsByClassName("content_2")[0];
      dom1 = dom1 || document.getElementsByClassName("content_1")[0];
      var length = dom1 ? dom1.offsetTop : 0;
      if (dom) {
        dom.scrollTop = length;
      }
    },
    go_page(type, data, source) {
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      let index = this.list.findIndex((item) => {
        return item.lessonId == data.lessonId;
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventLessonCardClicked",
        data: {
          lesson_id: data.lessonId,
          index: 1 + index,
          count: this.list.length,
        },
      });
      if (type == 0 || type == 1) return;
      this.saveLessonInfo(data);
      if (data.lessonType == 7) {
        this.$router.push("/homework");
        common.setSession("homeWorkTitle", data.title);
        LIMI_ENV === "electron" && this.getZip({ course_id: data.courseId });
      } else if (
        type == 2 ||
        ([121, 122, 123, 124, 126].includes(data.lessonType) && type == 3)
      ) {
        if (source) {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventLivingin",
          });
        }
        //正在上课
        if (this.lesson_id != this.liveVideoUrlData.lesson_id) {
          this.updataVideoUrlState({
            lesson_id: data.lessonId,
            live_video_url_stream: "",
            live_video_url_type: "",
            live_video_url: "",
          });
        }
        this.$router.push({
          name: "video",
          params: {
            name: "first",
          },
        });
      } else if (type == 3) {
        console.log("视频回放", data);
        //视频回放
        if (!data.playbackUrl && !data.hlsUrl) {
          this.showText = "回放上传中，请稍候";
          return;
        }

        let playbackData = {
          lesson_type: data.lessonType,
          play_back_url: data.hlsUrl ? data.hlsUrl : data.playbackUrl,
          playback_url_tag: data.playbackUrlTagList,
          time_length: data.timeLength,
          title: data.title,
          begin_time: data.beginTime,
        };
        this.savePlaybackData(playbackData);
        this.$router.push({
          path: "/playback",
        });
        LIMI_ENV === "electron" && this.getZip({ course_id: data.courseId });
      }
    },
    cancelEvent() {
      this.alertData.show = false;
    },
    playAmn() {
      if (this.lottie) return;
      this.lottie = true;
      let dom = document.querySelector(".lottie_voice");
      if (!dom || !dom.childElementCount) {
        this.anim = lottie.loadAnimation({
          container: dom, // the dom element that will contain the animation
          renderer: "svg", //svg,canvas
          loop: true,
          autoplay: true,
          path: "/static/lottie/composeclassing.json",
        });
      }
      setTimeout(() => {
        this.lottie = false;
      }, 1000);
    },
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
::-webkit-scrollbar {
  width: 0px;
}
/*五个小竖条*/
.lottie_voice {
  width: 34px;
  height: 34px;
  position: relative;
  top: -3px;
  margin-left: -5px;
}
/*粒子动画 结束*/
.course_list {
  width: 100%;
  overflow-y: scroll;
  margin-top: 83px;
  height: 100%;
  position: relative;
  padding-bottom: 120px;
  .content_box {
    width: 840px;
    position: relative;
    margin: 0 auto;
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-top: 67px;
    justify-content: flex-start;
    align-items: center;
    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 235px;
      height: 287px;
      padding-bottom: 15px;
      border-radius: 12px;
      &::after {
        content: "";
        position: absolute;
        bottom: 11px;
        left: 50%;
        transform: translateX(-50%);
        width: 145px;
        height: 40px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.15);
        z-index: 0;
      }
      &.content_0::after {
        display: none;
      }
      // margin-bottom: 50px;
      // box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
      .icon {
        position: relative;
        margin-top: -48px;
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        width: 180px;
        height: 198px;
        line-height: 198px;
        text-align: center;
        // background: #275db3;
        img {
          height: 72px;
        }
        .lock {
          width: 129px;
          height: 129px;
          position: absolute;
          z-index: 10;
          background: url("/static/img/course/iconbg/lock.png");
          background-size: cover;
        }
      }
      .attend_class {
        padding-top: 1px;
        width: 145px;
        height: 40px;
        border-radius: 10px;
        font-size: 16px;
        font-family: HYZhengYuan;
        font-weight: 600;
        text-align: center;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        color: black;
        mix-blend-mode: screen;
        background-color: #fff;
        position: relative;
        z-index: 1;
      }
      &.content_0 .attend_class {
        border: 1px solid #fff;
        background-color: rgba(255, 255, 255, 0.3);
      }
      .zhengyuantop {
        padding-top: 2px;
      }

      .headset {
        position: absolute;
        top: 50px;
        width: 215px;
        left: -31px;
        z-index: 1;
        display: none;
      }
      .flx {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .statuicon {
        &::before {
          content: "";
          display: inline-block;
          width: 7px;
          height: 2px;
          background: #55b89b;
          border-radius: 2px;
          margin: 2px;
        }
        &:first-child::before {
          display: none;
        }
        img {
          width: 32px;
          height: 32px;
        }
      }
      .statuicon_yuwen::before {
        background: #ff7b2b;
      }
      .statuicon_shuxue::before {
        background: #2d9cdf;
      }
      .statuicon_yingyu::before {
        background: #7b69ef;
      }
      .statuicon_beiyong::before {
        background: #ea674d;
      }
      .opa4::before {
        opacity: 0.4;
      }
      b {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: HYZhengYuan;
        opacity: 0.6;
        min-width: 130px;
        padding: 0 11px;
        height: 35px;
        line-height: 35px;
        font-size: 16px;
        border-radius: 20px;
        // transform: translateX(-50%);
        color: #275db3;
        letter-spacing: 0;
        text-align: center;
        // background-color: #bed1ee;
        background-size: 24px 24px;
        z-index: 11;
        img {
          width: 16px;
          height: 16px;
          line-height: 35px;
          margin-right: 7px;
        }
      }
      .bcoin1 {
        color: #fff;
        // background-color: #acd6f0;
      }
      .bcoin2 {
        color: #fff;
        // background-color: #ffd9ab;
      }
      .bcoin3 {
        color: #fff;
        // background-color: #c5b9db;
      }
      .bcoin4 {
        color: #fff;
        // background-color: #ffbdb0;
      }
      .bcoin5 {
        color: #fff;
        // background-color: #009773;
      }
      .classingyuwen {
        // background: #ed7227;
      }
      .classingshuxue {
        // background: transparent;
      }
      .classingyingyu {
        // background: transparent;
      }
      .classingxinshou {
        // background: transparent;
      }
      .classingbeiyong {
        // background: transparent;
      }
      .text,
      .text1,
      .text2,
      .text3 {
        // position: absolute;
        margin: 12px 0 10px;
        width: 200px;
        height: 48px;
        // top: 192px;
        // left: -31px;
        z-index: 10;
        color: #d06829;
        font-size: 20px;
        text-align: center;
        font-family: HYZhengYuan;
        font-weight: 600;
        line-height: 24px;
        word-break: break-word;
        overflow: hidden; /*必须结合的属性,当内容溢出元素框时发生的事情*/
        text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
        display: -webkit-box; /*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
        -webkit-line-clamp: 2; /*用来限制在一个块元素显示的文本的行数。*/
        /*! autoprefixer: off */
        -moz-box-orient: vertical;
        -webkit-box-orient: vertical;
        /*! autoprefixer: on */
      }
      .text1,
      .text6 {
        color: #ffffff;
      }
      .text2 {
        color: #ffffff;
      }
      .text3 {
        color: #ffffff;
      }
      .text4 {
        color: #ffffff;
      }
      .text5 {
        color: #ffffff;
      }
      .opa {
        opacity: 0.6;
      }
    }
    .shadowshuxue,
    .shadowkuaiji {
      background: linear-gradient(180deg, #1ea1ec, #7bd7f6);
      // box-shadow: 0px 4px 0px 0px #a5ddff;
    }
    .shadowyuwen {
      background: linear-gradient(181deg, #00826d 1%, #09d8c0 99%);
      // box-shadow: 0px 6px 0px 0px #ffe3c2;
    }
    .shadowwuli {
      background: linear-gradient(180deg, #f8ac00 8%, #ffcd5b);
    }
    .shadowyingyu {
      background: linear-gradient(180deg, #8a68f8 9%, #c09dfa);
      // box-shadow: 0px 4px 0px 0px #dbcaff;
    }
    .shadowxinshou {
      background: #f5fff9;
      // box-shadow: 0px 4px 0px 0px #b3f7d0;
    }
    .shadowbeiyong {
      background: #fff3f1;
      // box-shadow: 0px 4px 0px 0px #ffcec3;
    }
    .shadowhuaxue {
      background: linear-gradient(181deg, #57a753 1%, #98e896 99%);

      // box-shadow: 0px 4px 0px 0px #6de0a9;
    }
    .content:nth-child(3n + 2) {
      margin: 0 66px;
    }
  }
  .content {
    .icon {
      background: url(../../../../static/img/course/iconbg/shuxue/11.png)
        no-repeat;
      background-size: cover;
    }
    .icon.icon_yx {
      background: url(../../../../static/img/course/iconbg/shuxue/11.png)
        no-repeat;
      background-size: cover;
    }
    .icon.icon_xt {
      background: url(../../../../static/img/course/iconbg/shuxue/xt.png)
        no-repeat;
      background-size: cover;
    }
    .icon2 {
      background: url(../../../../static/img/course/iconbg/yuwen/22.png)
        no-repeat;
      background-size: cover;
    }
    .icon2.icon_yx {
      background: url(../../../../static/img/course/iconbg/yuwen/yx.png)
        no-repeat;
      background-size: cover;
    }
    .icon2.icon_xt {
      background: url(../../../../static/img/course/iconbg/yuwen/xt.png)
        no-repeat;
      background-size: cover;
    }
    .icon1,
    .icon6 {
      background: url(../../../../static/img/course/iconbg/shuxue/11.png)
        no-repeat;
      background-size: cover;
    }
    .icon1.icon_yx,
    .icon6.icon_yx {
      background: url(../../../../static/img/course/iconbg/shuxue/11.png)
        no-repeat;
      background-size: cover;
    }
    .icon1.icon_xt,
    .icon6.icon_xt {
      background: url(../../../../static/img/course/iconbg/shuxue/xt.png)
        no-repeat;
      background-size: cover;
    }

    .icon3 {
      background: url(../../../../static/img/course/iconbg/yingyu/33.png)
        no-repeat;
      background-size: cover;
    }
    .icon3.icon_yx {
      background: url(../../../../static/img/course/iconbg/yingyu/yx.png)
        no-repeat;
      background-size: cover;
    }
    .icon3.icon_xt {
      background: url(../../../../static/img/course/iconbg/yingyu/xt.png)
        no-repeat;
      background-size: cover;
    }
    .icon4 {
      background: url(../../../../static/img/course/iconbg/wuli/44.png)
        no-repeat;
      background-size: cover;
    }
    .icon4.icon_yx {
      background: url(../../../../static/img/course/iconbg/wuli/yx.png)
        no-repeat;
      background-size: cover;
    }
    .icon4.icon_xt {
      background: url(../../../../static/img/course/iconbg/wuli/xt.png)
        no-repeat;
      background-size: cover;
    }
    .icon5 {
      background: url(../../../../static/img/course/iconbg/huaxue/55.png)
        no-repeat;
      background-size: cover;
    }
    .icon5.icon_yx {
      background: url(../../../../static/img/course/iconbg/huaxue/yx.png)
        no-repeat;
      background-size: cover;
    }
    .icon5.icon_xt {
      background: url(../../../../static/img/course/iconbg/huaxue/xt.png)
        no-repeat;
      background-size: cover;
    }
  }

  .special {
    justify-content: space-around;
    .content:nth-child(3n + 2) {
      margin: 0;
    }
  }
  .content_box .content_0 {
    /*未开课*/
    .text1 {
      color: #ffffff;
    }
    .text2 {
      color: #ffffff;
    }
    .text4 {
      color: #ffffff;
    }
  }
  .content_box .content_1 {
    /*即将开课*/
    b {
      background-image: none;
      min-width: 140px;
      padding: 0 5px;
      text-align: center;
      color: #fff;
      // background-color: #009773;
    }
    .bdata1 {
      background-color: #00757b;
    }
    .bdata2 {
      background-color: #b66111;
    }
    .bdata3 {
      background-color: #6336b4;
    }
  }
  .content_box .content_2 {
    /*正在上课*/
    b {
      display: none;
    }
    .headset {
      display: block;
    }
    .bold {
      font-weight: bold;
    }
  }
  .content_box .novice_class {
    /*正在上课*/
    .icon1 {
      background: url(../../../../static/img/course/iconbg/xinshou/1.png)
        no-repeat;
      background-size: cover;
    }
    .text {
      color: #008565;
    }
  }
}
.practiceStatus {
  position: absolute;
  right: -5px;
  top: -2px;
  width: 68px;
  height: 35px;
  background: #e13131;
  border-radius: 13px 20px 20px 0px;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  line-height: 35px;
}
@media screen and (min-width: 1921px) {
  .content_box {
    width: 841px !important;
    // .content:nth-child(3n + 2) {
    //   margin: 0 183px !important;
    // }
  }
}
.hint {
  width: 200px;
  text-align: center;
  position: absolute;
  font-size: 32px;
  color: #fff;
  top: 50%;
  left: 50%;
  margin-top: -60px;
  transform: translate(-50%, -50%);
}
.u-time {
  height: 22px;
  line-height: 22px;
}
.u-time-box {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 0 10px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/courseCompose/compose_list.vue